import { WatchQueryFetchPolicy, useQuery } from "@apollo/client";
import { balanceQueryDocument } from "../apollo/queries/home.gql";
import { useMemo } from "react";
import { useAppState } from "./useAppState";

export enum FAILURE_CODE {
  "SOCIAL_ID" = "SOCIAL_ID", // thieu social Id
  "BANK_ACCOUNT" = "BANK_ACCOUNT", // thieu bank
  "CONTRACT_TYPE_FULL_TIME" = "CONTRACT_TYPE_FULL_TIME", // contract type
  "DAY_OF_MONTH" = "DAY_OF_MONTH", // gioi hanj ngay rut trong thang (crv)
  "DEDUCTION" = "DEDUCTION", // tru do nhieu ly do
  "PERIOD_ADVANCES_LIMIT" = "PERIOD_ADVANCES_LIMIT", // rut qua so lan trong thang
  "SALARY_CAP" = "SALARY_CAP", // luong qua cao
  "SENIORITY" = "SENIORITY", // 2 thang thu viec
  "STATUS" = "STATUS", // inactive nhung van dung cai ben ngoai`
  "TERMINATION" = "TERMINATION", //sap nghi viec
}

/**
 * Custom hook that retrieves withdrawal balance information.
 * @param fetchPolicy - The fetch policy for the GraphQL query (default: "cache-and-network").
 * @returns An object containing withdrawal balance information and other related data.
 */
function useWithdrawalBalance(
  fetchPolicy: WatchQueryFetchPolicy = "cache-and-network"
) {
  const {
    state: { accessToken },
  } = useAppState();

  const { data, refetch, networkStatus } = useQuery(balanceQueryDocument, {
    skip: !accessToken,
    fetchPolicy,
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  });

  const currentWorkPeriod = useMemo(() => {
    return data?.profile.currentEmployment?.currentWorkPeriod;
  }, [data?.profile.currentEmployment?.currentWorkPeriod]);

  const withdrawableBalance: number = useMemo(
    () => currentWorkPeriod?.withdrawableBalance?.value || 0,
    [currentWorkPeriod?.withdrawableBalance?.value]
  );

  const minAdvanceValue = useMemo(() => {
    if (data?.profile.currentEmployment?.group?.minAdvanceValue) {
      return data.profile.currentEmployment.group.minAdvanceValue.value;
    }
    return 100_000;
  }, [data?.profile.currentEmployment?.group?.minAdvanceValue]);

  const group = useMemo(() => {
    return data?.profile.currentEmployment?.group;
  }, [data?.profile.currentEmployment?.group]);

  const shouldShowGrayCard = useMemo(() => {
    const failure =
      data?.profile.currentEmployment?.currentWorkPeriod.advanceValidation
        .failure;

    if (
      failure
      // && failure.code !== FAILURE_CODE.DEDUCTION // khong phai loi kieu deduction => comment out because of new home design
    ) {
      return true;
    }

    return false;
  }, [data?.profile.currentEmployment?.currentWorkPeriod]);

  return {
    currentWorkPeriod,
    refetch,
    networkStatus,
    group,
    withdrawableBalance,
    minAdvanceValue,
    shouldShowGrayCard,
  };
}

export default useWithdrawalBalance;
